module.exports = __webpack_public_path__ + "img/home1.a59538b3.png";